export default __webpack_public_path__ + "static/media/partners5.639abf51.png";